import api from './api';

export const technicianService = {
  getAll: async (params = {}) => {
    const response = await api.get('/technicians', { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/technicians/${id}`);
    return response.data;
  },

  create: async (data) => {
    const response = await api.post('/technicians', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`/technicians/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/technicians/${id}`);
    return response.data;
  },

  getAvailable: async () => {
    const response = await api.get('/technicians/available');
    return response.data;
  },
};

export default technicianService;
